module.exports = __webpack_public_path__ + "img/profile_pic2.1030a3c9.jpeg";